<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('sap_order')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Created_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edited_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode == this.$FORM_MODE_EDIT || mode == this.$FORM_MODE_CREATE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('create_type')" fieldName="Type" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="header.Type" 
                                    :url="this.$API_URL + 'list/sap_order_type'" 
                                    :minLength="0" 
                                    :params="{ }" 
                                    v-if="header" 
                                    @change="onChangeCreateType"
                                    :filter="true"
                                    :disabled="!canEdit"
                                    />
                            </FormField>


                            <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="header.Order_Type" 
                                    :url="this.$API_URL + 'list/order_type_code'" 
                                    :minLength="0" 
                                    :params="{ use_sto: false, use_to: isTransferOrder, hidden_sap_filter: true}" 
                                    v-if="header" 
                                    @change="onChangeOrderType"
                                    @init-data="onChangeOrderType"
                                    :filter="true"
                                    :disabled="!canEdit"
                                    />
                            </FormField>

                            <FormField :labelName="$t('document_no')" fieldName="Document_No" v-model="header" v-if="!isCreate" fieldClass="col-6" labelClass="col-4">
                                <InputText name="Document_No" v-model="header.Document_No" type="text" v-if="header" :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('doc_date')" fieldName="Document_Date" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <DatePicker  v-model="header.Document_Date" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" :disabled="isSyncSAP || !canEdit"/>    
                            </FormField>

                            <FormField :labelName="$t('valid_from')" fieldName="Valid_From" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <div class="field grid" style="margin-bottom:0!important">
                                    <div class="col-5">
                                        <DatePicker v-model="header.Valid_From" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-inputtext-sm" v-if="header" :disabled="isSyncSAP || !canEdit"/>
                                    </div>
                                    <label for="Valid_To" class="col-2">To</label>
                                    <div class="col-5">
                                        <DatePicker v-model="header.Valid_To" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-inputtext-sm" v-if="header" :disabled="isSyncSAP || !canEdit"/>
                                    </div>
                                </div>
                            </FormField>

                            <FormField :labelName="$t('company')" fieldName="Doc_Date" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Company_Code" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true"/>
                            </FormField>

                            <FormField :labelName="$t('product_category')" fieldName="Product_Category" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Product_Category" :url="this.$API_URL + 'list/business_segment_code'" :minLength="0" :params="{ }" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true" />
                            </FormField>

                            <FormField :labelName="$t('plant')" fieldName="Plant" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Plant" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ company: header.Company_Code }" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true"/>
                            </FormField>

                            <!-- <FormField :labelName="$t('do_no')" fieldName="Delivery_Order_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate || this.header.Order_Type==this.$ORDER_TYPE.IPB">
                                <InputText :placeholder="$t('do_no')" name="Delivery_Order_No" v-model="header.DO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE"/>
                            </FormField> -->

                            <div v-if="!isTransferOrder">
                                <FormField :labelName="$t('ln_so_no')" fieldName="LN_SO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                                    <InputText :placeholder="$t('ln_so_no')" name="LN_SO_No" v-model="header.LN_SO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
                                </FormField>
                                
                                <FormField :labelName="$t('ln_sto_no')" fieldName="LN_STO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                                    <InputText :placeholder="$t('ln_sto_no')" name="LN_STO_No" v-model="header.LN_STO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
                                </FormField>

                                <FormField :labelName="$t('ln_do_third_party')" fieldName="LN_DO_Third_Party" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                                    <InputText :placeholder="$t('ln_do_third_party')" name="LN_DO_Third_Party" v-model="header.LN_DO_Third_Party" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
                                </FormField>
                            </div>
                        </div>
                        <div class="col-6">
                            <div v-if="useCustomer">
                                <FormField :labelName="$t('sales_org')" fieldName="Sales_Organization" v-model="header" fieldClass="col-6" labelClass="col-4">
                                    <CustomSelect :placeholder="$t('sales_org')" class="p-inputtext-sm" v-model="header.Sales_Organization" :url="this.$API_URL + 'list/sales_organization_code'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true" />
                                </FormField>
                            </div>
                            <div v-else-if="useVendor">
                                <FormField :labelName="$t('purchase_org')" fieldName="Purchase_Organization" v-model="header" fieldClass="col-6" labelClass="col-4">
                                    <CustomSelect :placeholder="$t('purchase_org')"  class="p-inputtext-sm" v-model="header.Purchase_Organization" :url="this.$API_URL + 'list/purchase_organization'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true" />
                                </FormField>
                            </div>

                            <FormField :labelName="$t('doc_type')" fieldName="Document_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect :placeholder="$t('doc_type')"  class="p-inputtext-sm" v-model="header.Document_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE }" v-if="header" :disabled="isSyncSAP || !canEdit" :filter="true"/>
                            </FormField>

                            <div v-if="isSyncSAP">
                                <FormField :labelName="$t('customer_vendor')" fieldName="Customer_Vendor_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
                                    <InputText name="Customer_Vendor_Code" v-model="header.Customer_Vendor_Code" type="text" v-if="header" :disabled="isSyncSAP || !canEdit || isTransferOrder" />
                                </FormField>
                            </div>
                            <div v-else>
                                <div v-if="useCustomer || useVendor">
                                    <FormField :labelName="useCustomer ? $t('customer') : $t('vendor')" fieldName="Customer_Vendor_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
                                         <div v-if="useCustomer">
                                            <CustomSelect 
                                                class="p-inputtext-sm" 
                                                v-model="header.Customer_Vendor_Code" 
                                                :url="this.$API_URL + 'list/customer_code'" 
                                                :minLength="0" 
                                                :params="{ company_code: header.Company_Code }" 
                                                v-if="header" 
                                                :disabled="isSyncSAP || !canEdit"
                                                @change="onChangeCustomerVendor"
                                                :filter="true"
                                                />
                                        </div>
                                        <div v-else>
                                            <CustomSelect 
                                                class="p-inputtext-sm" 
                                                v-model="header.Customer_Vendor_Code" 
                                                :url="this.$API_URL + 'list/vendor_code'" 
                                                :minLength="0" 
                                                :params="{ company_code: header.Company_Code, purchase_org: header.Purchase_Organization }" 
                                                v-if="header" 
                                                :disabled="isSyncSAP || !canEdit || isTransferOrder"
                                                @change="onChangeCustomerVendor"
                                                :filter="true"
                                                />
                                        </div>
                                    </FormField>
                                </div>
                            </div>

                            <FormField :labelName="$t('address')" fieldName="Address" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <Textarea name="Address" v-model="header.Address" type="text" v-if="header" :disabled="true" :autoResize="true"/>
                            </FormField>

                            <FormField :labelName="$t('distribution')" fieldName="Distribution" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useDistribution">
                                <div v-if="isSyncSAP">
                                    <InputText name="Distribution" v-model="header.Distribution" type="text" v-if="header" :disabled="isSyncSAP || !canEdit" />
                                </div>
                                <div v-else>
                                    <CustomSelect :placeholder="$t('distribution')" class="p-inputtext-sm" v-model="header.Distribution" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.DISTRIBUTION}" v-if="header" :disabled="!canEdit" :filter="true"/>
                                </div>
                            </FormField>

                            <FormField :labelName="$t('incoterm')" fieldName="Incoterm" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <div v-if="isSyncSAP">
                                    <InputText name="Incoterm" v-model="header.Incoterm" type="text" v-if="header" :disabled="true" />
                                </div>
                                <div v-else>
                                    <CustomSelect :placeholder="$t('incoterm')" class="p-inputtext-sm" v-model="header.Incoterm" :url="this.$API_URL + 'list/incoterm_code'" :minLength="0" :params="{}" v-if="header" :disabled="!canEdit || isTransferOrder" :filter="true" @change="onChangeIncoterm"/>
                                </div>
                            </FormField>

                            <FormField :labelName="$t('estate')" fieldName="Estate" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useGR">
                                 <CustomSelect class="p-inputtext-sm" v-model="header.Estate" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEdit" :filter="true" />
                            </FormField>

                            <div v-if="!isTransferOrder">
                                <FormField :labelName="$t('incoterm2')" fieldName="Incoterm2" v-model="header" fieldClass="col-6" labelClass="col-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Incoterm2" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEdit" :filter="true" />
                                </FormField>

                                <FormField :labelName="$t('collective_ln')" fieldName="Collective_LN" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                                    <InputText :placeholder="$t('collective_ln')" name="Collective_LN" v-model="header.Collective_LN" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
                                </FormField>

                                <FormField :labelName="$t('delivery_using_truck')" fieldName="Delivery_Using_Truck" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                                    <InputText :placeholder="$t('delivery_using_truck')" name="Delivery_Using_Truck" v-model="header.Delivery_Using_Truck" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
                                </FormField>
                            </div>

                        </div>
                    </div>

                    <div class="grid" v-if="isTransferOrder">
                        <Divider />

                        <div class="col-6">
                            <FormField :labelName="$t('sto_spo_per_shipment')" fieldName="STO_SPO_Per_Shipment" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <YNCheckbox v-model="header.STO_SPO_Per_Shipment" :disabled="!canEdit" :binary="true"/>
                            </FormField>

                            <FormField :labelName="$t('langsir_type')" fieldName="Langsir_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect :placeholder="$t('langsir_type')" class="p-inputtext-sm" v-model="header.Langsir_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.LANGSIR_TYPE}" v-if="header" :disabled="!canEdit || !is_TO_OUT" :filter="true" @change="onChangeLangsirType"/>
                            </FormField>
                        </div>
                        <div class="col-6">
                            <FormField :labelName="$t('plant_destination')" fieldName="Plant_Destination" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Plant_Destination" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEditAdditional || !isLangsir" :filter="true"/>
                            </FormField>

                            <FormField :labelName="$t('factory_destination')" fieldName="Factory_Destination" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Factory_Destination" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEditAdditional || !isLangsir" :filter="true"/>
                            </FormField>
                        </div>
                    </div>


                    <Divider />

                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('warehouse')" fieldName="Warehouse_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Warehouse_Code" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEditAdditional || header.has_order" :filter="true"/>
                            </FormField>

                            <FormField :labelName="$t('shipment_type')" fieldName="Shipment_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <CustomSelect :placeholder="$t('shipment_type')" class="p-inputtext-sm" v-model="header.Shipment_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.SHIPMENT_TYPE, allow_all: true}" v-if="header" :disabled="!canEditAdditional || isLangsir || deliveryUsingTruck || !canChangeShipmentType" :filter="true"/>
                            </FormField>

                            <!-- <div v-if="isRelation">
                                <div class="field grid">
                                    <label for="Loading_Destination_From_Id" class="col-4">{{$t('loading')}}</label>
                                    <div class="col-6 md-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_From_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEditAdditional" :filter="true" />
                                        <Skeleton v-else-if="!header" />
                                    </div>
                                </div>
                                <div class="field grid">
                                    <label for="Loading_Destination_To_Id" class="col-4">{{$t('destination')}}</label>
                                    <div class="col-6 md-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_To_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :disabled="!canEditAdditional" :filter="true" />
                                        <Skeleton v-else-if="!header" />
                                    </div>
                                </div>
                            </div> -->
                            
                        </div>

                        <div class="col-6">
                            
                            <FormField :labelName="$t('delivery_address')" fieldName="Delivery_Address" v-model="header" fieldClass="col-6" labelClass="col-4">
                                <!-- <Textarea name="Delivery_Address" v-model="header.Delivery_Address" type="text" v-if="header" :disabled="!canEditAdditional || header.has_order" :autoResize="true" /> -->
                                <Textarea name="Delivery_Address" v-model="header.Delivery_Address" type="text" v-if="header" :disabled="!canEditAdditional" :autoResize="true" />
                            </FormField>

                            <!-- <div v-if="isRelation">
                                <div class="field grid">
                                    <label for="Stuffing_Date" class="col-4">{{$t('stuffing_date')}}</label>
                                    <div class="col-6 md-4">
                                        <InputText name="Stuffing_Date" v-model="header.Stuffing_Date" type="text" v-if="header" :disabled="!canEditAdditional"  />
                                        <Skeleton v-else-if="!header" />
                                    </div>
                                </div>
                            </div> -->
                            


                        </div>
                    </div>

                    <div class="grid">
                        <div class="col-12">
                           <!-- <div class="col-offset-11">
                                <Button label="Sync" class="p-button-help mr-2" @click="syncDOSAP" v-if="(useDO || useSO) && mode == $FORM_MODE_EDIT"/>
                            </div> -->
                        </div>
                        <div class="col-12 mt-2">
                            <DataTable v-if="header" :loading="!header.Details" :value="header.Details ? header.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column v-if="canEdit || !isSyncSAP" :exportable="false" bodyStyle="width:30px;display:table-cell">
                                    <template #header="">
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" :disabled="!canEdit"/>
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="!canEdit" />
                                    </template>
                                </Column>
                                <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%" v-if="mode != $FORM_MODE_CREATE">   
                                </Column>
                                <Column field="material_name" :header="$t('material_name')" key="material_name">
                                    <template #body="slotProps">
                                        <span v-if="isSyncSAP || !canEdit">{{slotProps.data['material_name']}}</span>
                                        <CustomSelect 
                                            v-else 
                                            class="p-inputtext-sm" 
                                            v-model="slotProps.data['Material_Code']" 
                                            :url="this.$API_URL + 'list/material_code_v2'" 
                                            :minLength="0" 
                                            :params="{ company_code: header.Company_Code, plant_code: header.Plant, business_segment_code: header.Product_Category}" 
                                            :disabled="!canEdit" 
                                            @change="onChangeMaterial($event, slotProps)"
                                            :filter="true"
                                            />
                                    </template>
                                </Column>
                                <Column field="Qty" :header="$t('qty')" key="Qty" style="width:15%">
                                    <template #body="slotProps">
                                        <span v-if="isSyncSAP || !canEdit">{{slotProps.data['Qty']}}</span>
                                        <div class="p-fluid" v-else>
                                            <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :optionalDecimal="true" :disabled="!canEdit" />
                                        </div>
                                    </template>
                                </Column>
                                <Column field="UOM" :header="$t('uom')" key="UOM" style="width:10%">
                                </Column>
                                <Column field="Tolerance" :header="$t('tolerance')" key="Tolerance" style="width:15%" v-if="isTransferOrder">
                                    <template #body="slotProps">
                                        <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :optionalDecimal="true" :disabled="!canEdit && isTransferOrder" />
                                    </template>
                                </Column>
                                <Column field="PO_SO_No" :header="$t('po_so_no')" key="PO_SO_No" style="width:15%" v-if="!isCreate">
                                </Column>
                                 <Column field="SO_DO_No" :header="$t('so_do_no')" key="SO_DO_No" style="width:15%" v-if="!isCreate && useDO">
                                </Column>
                                <Column field="SO_DO_Item_No" :header="$t('so_do_item_no')" key="SO_DO_No" style="width:15%" v-if="!isCreate && useDO">
                                </Column>
                                <Column field="LN_SO_Item_No" :header="$t('ln_so_item_no')" key="LN_SO_Item_No" style="width:15%" v-if="!isCreate && !useDO && !useSO">
                                </Column>
                                 <Column field="LN_STO_Item_No" :header="$t('ln_sto_item_no')" key="LN_STO_Item_No" style="width:15%" v-if="!isCreate && !useDO && !useSO">
                                </Column>
                                <Column field="Sales_District" :header="$t('sales_district')" key="Sales_District" style="width:15%" v-if="!isCreate">
                                </Column>
                                <!--<Column field="SO_Factory_No" :header="$t('so_factory_no')" v-if="useDO ||useSO"  style="width:15%">
                                    <template #body="slotProps">
                                        <InputText name="SO_Factory_No" v-model="slotProps.data.SO_Factory_No" type="text" @change="setRequireSync(); editDetail(slotProps);" class="w-10rem" />
                                    </template>
                                </Column>
                                <Column field="SO_Factory_Item_No" :header="$t('so_factory_item_no')" v-if="useDO || useSO"  style="width:15%">
                                    <template #body="slotProps">
                                        <InputText name="SO_Factory_Item_No" v-model="slotProps.data.SO_Factory_Item_No" type="text" @change="setRequireSync(); editDetail(slotProps);" class="w-10rem"  modelValue=""/>
                                    </template>
                                </Column>
                                <Column field="SO_Factory_Result" :header="$t('result')" v-if="(useDO || useSO) && mode == $FORM_MODE_EDIT">
                                </Column>
                                <Column field="SO_Factory_Result_Reason" :header="$t('remarks')" v-if="(useDO || useSO) && mode == $FORM_MODE_EDIT">    
                                </Column>
                                <Column field="PO_SO_Factory" :header="$t('po_so_factory')" v-if="useDO || useSO">    
                                </Column>
                                -->
                            </DataTable>
                        </div>
                    </div>

                </div>
            </template>
        </Card>
    </form>
</template>


<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "SAPOrderIndex",
                url: this.$API_URL + "saporder/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                isCreate: false,
                isSyncSAP: false,
                isRelation: false,
                useCustomer: false,
                useVendor: false,
                useGR: false,
                useDistribution: false,
                canChangeShipmentType: true,
                isTransferOrder: false,
                isLangsir: false,
                is_TO_OUT: false,   
                useDO: false,
                syncSAPSuccess: false,
                requireSync: false,
                phase2: false,
                useSO: false
            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        if(response.data.success){
                            self.header = response.data.data.header;
                            self.detail = response.data.data.detail;

                            
                            self.isSyncSAP = self.header.Type == self.$ORDER_CREATE_TYPE.SYNC_SAP;
                            self.isRelation = self.header.is_relation;
                            if(self.isRelation){
                                self.header.Shipment_Type = self.$SHIPMENT_TYPE.RELATION;
                            }

                             self.header.mode = self.mode;

                            if(self.header.is_relation_setting){
                                self.canChangeShipmentType = false;
                                if(self.header.Type == self.$ORDER_CREATE_TYPE.TRANSFER_ORDER){
                                    self.isTransferOrder = true;
                                }

                                self.isCreate = self.mode == self.$FORM_MODE_CREATE;
                                self.header.mode = self.mode;

                                self.phase2 = self.header.phase;

                                // self.header.Company_Code = "AN";
                                // self.header.Product_Category = "SPECIALTY FATS";
                                // self.header.Sales_Organizaiton = "ANSF";
                                // self.header.Plant = "AN01";
                                // self.header.Distribution = "B2B";
                                // self.header.Document_Type = "IMPORT";

                            }
                            else{
                                //console.log("error");
                            }
                        
                        }
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            saveData() {
                // console.log(this.header)
                // return;
                
                this.$emit('block-ui');
                var self = this;

                if((this.useDO || this.useSO) && this.requireSync){
                    if(!this.syncSAPSuccess)
                    {
                        self.showError('Error Saving Data', 'NOT OK');
                        return;
                    }
                }

                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/SAPOrder/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            addDetail(){
                var det = { ...this.detail };
                det.mode = this.$FORM_MODE_CREATE;
                this.header.Details.push(det);
            },
            deleteDetail(event){
                if (event) {
                    var detail = this.header.Details[event.index];
                    this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                }
            },
            editDetail(event){
                if(event.data){
                    event.data.mode = this.$FORM_MODE_EDIT;
                }
            },
            onChangeOrderType(event){
                var self =this;
                self.is_TO_OUT = event.name == self.$ORDER_TYPE_NAME.TO_OUT;

                this.$axios.get(this.$UTIL_URL + "order_type_fields_code?code=" + event.id)
                    .then((response) => {
                        if(response && response.data.success){
                            self.useCustomer = response.data.data.Use_Customer;
                            self.useVendor = response.data.data.Use_Vendor;
                            self.useGR = response.data.data.Use_GR;
                            self.useDO = response.data.data.Use_DO;
                            self.useSO = response.data.data.Use_SO;
                            self.useDistribution = response.data.data.Use_Distribution;
                            if(response.data.data.Use_STO){
                                self.header.Customer_Vendor_Code = "OTHERS";
                                self.header.Incoterm = "OTH";
                            }
                        }
                    })
                    .catch((error) => {
                        self.showError('Error Getting Order Type Data', error);
                    });

                this.getOrderTypeInfo1(event.id, event.name);
                this.checkOrderRelation();
                this.onChangeCreateTypeData(this.header.Type);
            },
            onChangeIncoterm(){
                this.checkOrderRelation();
            },
            getOrderTypeInfo1(code, name){
                var self = this;
                this.$axios.get(this.$UTIL_URL + "order_type_fields_code_name?code=" + code + "&name=" + name)
                    .then((response) => {
                        if(response && response.data.success){
                            self.header.Transfer_Type = response.data.data.Info1;
                        }
                    })
                    .catch((error) => {
                        self.showError('Error Getting Order Type Data', error);
                    });
            },
            checkOrderRelation(){
                var incoterm = this.header.Incoterm;
                var orderType = this.header.Order_Type;
                var self = this;

                this.$axios.get(this.$UTIL_URL + "order_is_relation?incoterm=" + incoterm + "&order_type=" + orderType)
                    .then((response) => {
                        if(response && response.data.success){
                            self.isRelation = response.data.data;

                            if(self.isRelation)
                                self.header.Shipment_Type = self.$SHIPMENT_TYPE.RELATION;
                        }
                        
                    })
                    .catch((error) => {
                        self.showError('Error Getting Order Type Data', error);
                    });
            },
            onChangeCustomerVendor(event){
                var self = this;
                console.log(event);
                this.header.Customer_Vendor_Code = event.id;
                this.header.Address = event.address;
            },
            onChangeMaterial(event, slotProps){
                var index = slotProps.index;

                var detail = this.header.Details[index];
                detail.UOM = event.uom;
            },
            onChangeCreateType(event){
                this.header.Order_Type = null;
                
                this.isTransferOrder = event.id == this.$ORDER_CREATE_TYPE.TRANSFER_ORDER ? true : false;

                this.onChangeCreateTypeData(event.id);
                
            },
            onChangeCreateTypeData(createType){
                var self = this;

                if(createType && this.header.Order_Type && this.mode == this.$FORM_MODE_CREATE){
                    var data = {
                        type: createType,
                        order_type: this.header.Order_Type
                    };

                    
                        self.$emit('block-ui');
                        this.$axios.post(this.$UTIL_URL + "check_sap_order_type", data)
                        .then((response) => {
                            if(response && response.data.success){
                                var data = response.data.data;

                                self.isTransferOrder = data.is_transfer_order;
                                
                                if(self.isTransferOrder){
                                    self.header.Customer_Vendor_Code = data.default_model.vendor;
                                    self.header.Incoterm = data.default_model.incoterm;
                                    self.header.Document_Type = data.default_model.document_type;
                                }
                            }

                            
                        self.$emit('unblock-ui');
                        })
                        .catch((error) => {
                            self.showError('Error Getting SAP Create Type Data', error);
                            
                        self.$emit('unblock-ui');
                        });
                }
            },
            onChangeLangsirType(event){
                var self = this;

                self.header.Shipment_Type = event.Lookup_Info2;

                this.isLangsir = event.Lookup_Info1 == "Y";
            },
            setRequireSync(){
                this.requireSync = true;
            },
            syncDOSAP(){
                var self = this;

                this.$emit('block-ui');

                 this.$axios.post(this.url + "sync_do_sap", this.header)
                    .then((response) => {
                        if(response){
                            if(response.data.data){
                                var data = response.data.data;
                                self.header.Details = data;
                                if(response.data.success)
                                    self.requireSync = false;
                            }

                            self.syncSAPSuccess = response.data.success;
                            if(self.syncSAPSuccess == false){
                                self.showError('Error Sync to SAP', response.data.message);
                                self.requireSync = true;
                            }                            
                        }

                        self.$emit('unblock-ui');
                    })
                    .catch((error) => {
                        self.showError('Error Sync to SAP', error);

                        self.$emit('unblock-ui');
                    });
            }
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed:{
            canEdit(){
                var editable = false;

                if(this.mode == this.$FORM_MODE_EDIT && this.header){
                    if(this.header.Status == this.$ORDER_STATUS.WAITING_FOR_APPROVAL && this.header.Type == this.$ORDER_CREATE_TYPE.MANUAL){
                        editable = true;
                    }
                }
                else if(this.mode == this.$FORM_MODE_CREATE){
                    editable = true;
                }

                return editable;
            },
            canEditAdditional(){
                var editable = false;

                if(this.mode == this.$FORM_MODE_EDIT && this.header){
                    editable = true;
                }
                else if(this.mode == this.$FORM_MODE_CREATE){
                    editable = true;
                }
                
                return editable
            },
            deliveryUsingTruck(){
                return this.header ? this.header.Delivery_Using_Truck == "Y" : false;
            }


        }
    }
</script>